import React from 'react';
import { Flex, Spin } from '@bb/elements-web';

/**
 * A reusable loading spinner component for the Answering Service page.
 */
const StyledLoading: React.FC = () => (
  <Flex justify="center" align="center" style={{ width: '100%' }}>
    <Spin dataCy="answering-service-subscribe-loading" size="large" />
  </Flex>
);

export default StyledLoading;
